export enum BadgeStatusEnum {
    SUCCESS = 'SUCCESS',
    PRIMARY = 'PRIMARY',
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    DEFAULT = 'DEFAULT',
    INFO = 'INFO',
}
